import { FormlyFieldConfig } from "@ngx-formly/core";
import { AllegatiBolliAltroStep } from "../../shared/allegati-bolli-altro.step";


export const OccupazioneDehorStep : FormlyFieldConfig[] =
    [
        {
            "fieldGroup": [
                {
                    "wrappers": ['group-panel'],
                    "key": 'jd.elementi_occupazione',
                    "type":'repeat',
                    "defaultValue": [null],
                    "fieldGroupClassName": "flex flex-col border border-t-4 border-t-primary shadow-sm rounded-xl mb-6 mt-4 w-full",
                    "props": {
                        "addText": '+ AGGIUNGI ELEMENTO',
                        "label": "ELEMENTI DI OCCUPAZIONE SUOLO PER DEHOR",
                        "required": true
                    },
                    "fieldArray": {
                        "fieldGroupClassName": 'border border-t-4 p-4 shadow-sm rounded-xl mb-2 grid md:grid-cols-3 sm:grid-cols-1 gap-2 md:w-280 sm:w-full',
                        "fieldGroup": [
                            {
                                "className": 'sm:col-span-1 md:col-span-1',
                                "key": 'lunghezza',
                                type: 'mat-input',
                                "props": {
                                    "label": 'LUNGHEZZA (METRI)',
                                    "required": true,
                                    "type": 'number'
                                },
                            },
                            {
                                "className": 'sm:col-span-1 md:col-span-1',
                                "key": 'larghezza',
                                type: 'mat-input',
                                "props": {
                                    "label": 'LARGHEZZA (METRI)',
                                    "required": true,
                                    "type": 'number'
                                },
                            },
                            {
                                "className": 'sm:col-span-1 md:col-span-1 radio-inline',
                                "key": 'sosta',
                                type: 'mat-radio',
                                "props": {
                                    "label": 'RICADE IN AREA DI SOSTA',
                                    "required": true,
                                    "color": 'primary',
                                    "description": "Aree di sosta su strisce blu",
                                    "options": [
                                        { "value": 'si', 'label': 'SI' },
                                        { "value": 'no', "label": 'NO' }
                                    ],
                                },
                            },
                        ]
                    },
                },
            ]
        },
        {
            "key": 'jd.descrizione_occupazione',
            type: 'mat-textarea',
            "props": {
                "label": "DESCRIZIONE ELEMENTI PRESENTI ALL'INTERNO",
                "autosize": true,
                "required": true,
                "autosizeMaxRows": 4,
                "autosizeMinRows": 2,
                "description": "INDICARE GLI ELEMENTI MOBILI PRESENTI ALL'INTERNO COME TIPOLOGIA E NUMERO DI TAVOLINI E SEDIE, NUMERO DI FIORIERE, ECC."
            },
        },
        {
            "fieldGroupClassName": 'border border-t-4 p-4 shadow-sm rounded-xl mb-4 mt-4 grid sm:grid-cols-1 md:grid-cols-3 gap-2',
            "fieldGroup": [
                {
                    "className": 'md:col-span-1 sm_col-span-1',
                    "key": 'jd.copertura_opt',
                    type: 'mat-radio',
                    "props": {
                        "label": 'SONO PRESENTI ELEMENTI DI COPERTURA?',
                        "required": true,
                        "color": 'primary',
                        "options": [
                            { "value": 'si', 'label': 'SI' },
                            { "value": 'no', "label": 'NO' }
                        ],
                    },
                },
                {
                    "className": 'md:col-span-1 sm_col-span-1',
                    "key": 'jd.tenda_opt',
                    type: 'mat-select',
                    "props": {
                        "label": 'TIPO DI COPERTURA',
                        "options": [
                            { "value": 'TENDA A BRACCIO', "label": 'TENDA A BRACCIO' },
                            { "value": 'TENDA A CAPANNA', "label": 'TENDA A CAPANNA' },
                            { "value": 'OMBRELLONE', "label": 'OMBRELLONE' },
                            { "value": 'STRUTTURA IN DEROGA', "label": 'STRUTTURA IN DEROGA' }

                        ],
                        "required": true,
                    },
                    "expressions": {
                        "hide": "!(model.jd.copertura_opt == 'si')",
                    },
                },
                {
                    "className": 'md:col-span-3 sm_col-span-1',
                    "key": 'jd.copertura_descrizione',
                    type: 'mat-textarea',
                    "props": {
                        "label": "DESCRIZIONE DEGLI ELEMENTI DI COPERTURA (INDICARE COLORE E DIMENSIONI)",
                        "autosize": true,
                        "autosizeMaxRows": 8,
                        "autosizeMinRows": 2,
                        "required": true
                    },
                    "expressions": {
                        "hide": "!(model.jd.copertura_opt == 'si')",
                    },
                },
            ],

        },


        {
            "fieldGroupClassName": 'border border-t-4 p-4 shadow-sm rounded-xl mb-4 grid md:grid-cols-3 sm:grid-cols-1 gap-2',
            "fieldGroup": [
                {
                    "className": 'md:col-span-1 sm_col-span-1',
                    "key": 'jd.pedana_opt',
                    type: 'mat-radio',
                    "props": {
                        "label": "SONO PRESENTI PEDANE ALL'INTERNO DEL DEHOR?",
                        "required": true,
                        "color": 'primary',
                        "options": [
                            { "value": 'si', 'label': 'SI' },
                            { "value": 'no', "label": 'NO' }
                        ],
                    },
                },
                {
                    "className": 'md:col-span-1 sm_col-span-1',
                    "key": 'jd.pedana_altezza',
                    type: 'mat-input',
                    "props": {
                        "label": 'ALTEZZA DELLA PEDANA (CM)',
                        "required": true,
                        "type": 'number'
                    },
                    "expressions": {
                        "hide": "!(model.jd.pedana_opt == 'si')",
                    },
                },
                {
                    "className": 'md:col-span-3 sm_col-span-1',
                    "key": 'jd.pedana_descrizione',
                    type: 'mat-textarea',
                    "props": {
                        "label": "DESCRIZIONE PEDANA",
                        "autosize": true,
                        "autosizeMaxRows": 8,
                        "autosizeMinRows": 2,
                        "required": true
                    },
                    "expressions": {
                        "hide": "!(model.jd.pedana_opt == 'si')",
                    },
                },

            ],

        },
        {
            "fieldGroupClassName": 'border border-t-4 p-4 shadow-sm rounded-xl mb-4 grid md:grid-cols-3 sm:grid-cols-1 gap-2',
            "fieldGroup": [
                {
                    "className": 'md:col-span-1 sm_col-span-1',
                    "key": 'jd.rampa_opt',
                    type: 'mat-radio',
                    "props": {
                        "label": "È PRESENTE UNA RAMPA ALL'INTERNO DEL DEHOR?",
                        "required": true,
                        "color": 'primary',
                        "options": [
                            { "value": 'si', 'label': 'SI' },
                            { "value": 'no', "label": 'NO' }
                        ]
                    },
                },
                {
                    "className": 'md:col-span-1 sm_col-span-1',
                    "key": 'jd.rampa_varco',
                    "type":'mat-input',
                    "props": {
                        "label": 'DIMENSIONE VARCO RAMPA [M]',
                        "required": true,
                        "type": 'number'
                    },
                    "expressions": {
                        "hide": "!(model.jd.rampa_opt == 'si')",
                    },
                },
                {
                    "className": 'md:col-span-1 sm_col-span-1',
                    "key": 'jd.rampa_pendenza',
                    type: 'mat-input',
                    "props": {
                        "label": 'PENDENZA RAMPA(%)',
                        "required": true,
                        "type": 'number'
                    },
                    "expressions": {
                        "hide": "!(model.jd.rampa_opt == 'si')",
                    },
                },
                {
                    "className": 'md:col-span-3 sm_col-span-1',
                    "key": 'jd.rampa_descrizione',
                    type: 'mat-textarea',
                    "props": {
                        "label": "DESCRIZIONE RAMPA",
                        "autosize": true,
                        "autosizeMaxRows": 8,
                        "autosizeMinRows": 2,
                        "required": true
                    },
                    "expressions": {
                        "hide": "!(model.jd.rampa_opt == 'si')",
                    },
                },
            ],

        },
        {
            "fieldGroupClassName": 'border border-t-4 p-4 shadow-sm rounded-xl mb-4 grid md:grid-cols-3 sm:grid-cols-1 gap-2',
            "fieldGroup": [
                {
                    "className": 'md:col-span-1 sm_col-span-1',
                    "key": 'jd.antivento_opt',
                    type: 'mat-radio',
                    "props": {
                        "label": "SONO PRESENTI BARRIERE ANTIVENTO?",
                        "required": true,
                        "color": 'primary',
                        "options": [
                            { "value": 'si', 'label': 'SI' },
                            { "value": 'no', "label": 'NO' }
                        ],
                    },
                },
                {
                    "className": 'md:col-span-1 sm_col-span-1',
                    "key": 'jd.antivento_altezza',
                    type: 'mat-input',
                    "props": {
                        "label": 'ALTEZZA BARRIERA ANTIVENTO [M]',
                        "required": true,
                        "type": 'number'
                    },
                    "expressions": {
                        "hide": "!(model.jd.antivento_opt == 'si')"
                    },
                },
                {
                    "className": 'md:col-span-3 sm_col-span-1',
                    "key": 'jd.antivento_descrizione',
                    type: 'mat-textarea',
                    "props": {
                        "label": 'DESCRIZIONE BARRIERA ANTIVENTO',
                        "autosize": true,
                        "autosizeMaxRows": 8,
                        "autosizeMinRows": 2,
                        "required": true
                    },
                    "expressions": {
                        "hide": "!(model.jd.antivento_opt == 'si')"
                    }
                },
            ],

        },

        {
            "key": 'jd.note_occupazione',
            "defaultValue":'',
            type: 'mat-textarea',
            "props": {
                "label": 'ANNOTAZIONI',
                "autosize": true,
                "autosizeMaxRows": 8,
                "autosizeMinRows": 2,
            },
        },
                ...AllegatiBolliAltroStep
    ]

